
import { ChevronsUpDown, CircleUserRound } from "lucide-react"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { SidebarMenuButton } from "@/components/ui/sidebar"
import { forwardRef } from "react"

interface UserMenuTriggerProps {
  user: {
    name: string
    email: string
    avatar: string
  }
}

export const UserMenuTrigger = forwardRef<HTMLButtonElement, UserMenuTriggerProps>(
  ({ user, ...props }, ref) => {
    return (
        <SidebarMenuButton
        ref={ref}
        className="w-full h-auto p-2 data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground group-data-[collapsible=icon]:justify-center"
        role="button"
        aria-expanded="false"
        aria-haspopup="menu"
        {...props}
      >
        <div className="flex w-full items-center gap-2 group-data-[collapsible=icon]:justify-center">
          <Avatar className="h-8 w-8 rounded-lg">
            <AvatarImage src={user.avatar} alt={user.name} />
            <AvatarFallback className="rounded-lg">
              <CircleUserRound className="h-5 w-5" />
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:sr-only">
            <span className="truncate font-semibold">{user.name}</span>
            <span className="truncate text-xs text-muted-foreground">
              {user.email}
            </span>
          </div>
          <ChevronsUpDown className="ml-auto size-4 group-data-[collapsible=icon]:sr-only" />
        </div>
      </SidebarMenuButton>
    )
  }
)

UserMenuTrigger.displayName = "UserMenuTrigger"
